import { propEq } from 'ramda';
import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';
import type { PropsOf, NeedsProps, InjectsProps } from '@peloton/react';
import type { LibrarySelectorState } from '@engage/library';
import {
  canFetchNextPage,
  isLoading,
  getClassPreviews,
  isEmptyState,
} from '@engage/library';
import { BookmarkSource, toggleBookmarkClass } from '@members/classes';
import ClassesView from './ClassesView';
import InfiniteScrollEnhancer from './InfiniteScrollEnhancer';
import NoClasses from './NoClasses';

const ConnectEnhancer = connect(
  (state: LibrarySelectorState) => ({
    hasPageAvailable: canFetchNextPage(state),
    isLoading: isLoading(state),
    classes: getClassPreviews(state),
    isEmptyState: isEmptyState(state),
  }),
  { onBookmarkClick: toggleBookmarkClass(BookmarkSource.OnDemand, '') },
);

export type Props = PropsOf<typeof ConnectEnhancer> &
  InjectsProps<typeof InfiniteScrollEnhancer>;

export default compose<
  Props,
  Pick<NeedsProps<typeof InfiniteScrollEnhancer>, 'loadMore'>
>(
  ConnectEnhancer,
  branch<Props>(propEq('isEmptyState', true), renderComponent(NoClasses)),
  InfiniteScrollEnhancer,
)(ClassesView);
